const DNI_TABLE = 'TRWAGMYFPDXBNJZSQVHLCKE'

export interface DocumentValidation {
  valid: boolean
  message?: string
  type?: 'DNI' | 'NIE' | 'PASSPORT' | 'UNKNOWN'
}

export function validateDocumentId(value: string): DocumentValidation {
  const trimmed = value.trim().toUpperCase()

  if (!trimmed) {
    return { valid: true, type: 'UNKNOWN' }
  }

  // DNI: 8 digits + letter
  const dniMatch = trimmed.match(/^(\d{8})([A-Z])$/)
  if (dniMatch) {
    const number = parseInt(dniMatch[1], 10)
    const letter = dniMatch[2]
    const expected = DNI_TABLE[number % 23]
    if (letter !== expected) {
      return {
        valid: false,
        message: `La letra de control no coincide. Deberia ser ${expected}`,
        type: 'DNI',
      }
    }
    return { valid: true, type: 'DNI' }
  }

  // NIE: X/Y/Z + 7 digits + letter
  const nieMatch = trimmed.match(/^([XYZ])(\d{7})([A-Z])$/)
  if (nieMatch) {
    const prefix = nieMatch[1]
    const number = parseInt(nieMatch[2], 10)
    const letter = nieMatch[3]
    const prefixNum = prefix === 'X' ? 0 : prefix === 'Y' ? 1 : 2
    const fullNumber = parseInt(`${prefixNum}${String(number).padStart(7, '0')}`, 10)
    const expected = DNI_TABLE[fullNumber % 23]
    if (letter !== expected) {
      return {
        valid: false,
        message: `La letra de control no coincide. Deberia ser ${expected}`,
        type: 'NIE',
      }
    }
    return { valid: true, type: 'NIE' }
  }

  // Passport: if it contains letters and numbers but doesn't match DNI/NIE
  if (/^[A-Z0-9]{6,20}$/i.test(trimmed)) {
    return { valid: true, type: 'PASSPORT' }
  }

  return {
    valid: false,
    message: 'Formato no reconocido. Use 12345678A (DNI) o X1234567A (NIE)',
    type: 'UNKNOWN',
  }
}

export function formatDocumentId(value: string): string {
  const trimmed = value.trim().toUpperCase()
  // DNI: 12345678A
  if (/^\d{8}[A-Z]$/i.test(trimmed)) return trimmed
  // NIE: X1234567A
  if (/^[XYZ]\d{7}[A-Z]$/i.test(trimmed)) return trimmed
  return trimmed
}
